import {
	CreateBlockingRuleMutation,
	CreatePromotionRuleMutation,
	DeleteBlockingRuleMutation,
	DeletePromotionRuleMutation,
	UpdateBlockingRuleMutation,
	UpdatePromotionRuleMutation
} from "~/gql/mutations/restock/replenishmentRules.generated";
import {
	GetBlockingRuleQuery,
	GetPromotionRuleQuery,
	GetReplenishmentRuleGroupsQuery,
	GetReplenishmentRulesQuery
} from "~/gql/queries/restock/replenishmentRules.generated";

export const replenishmentRulesEndpoints = {
	CreateBlockingRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: CreateBlockingRuleMutation) => res
	},
	CreatePromotionRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: CreatePromotionRuleMutation) => res
	},
	DeleteBlockingRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: DeleteBlockingRuleMutation) => res
	},
	DeletePromotionRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: DeletePromotionRuleMutation) => res
	},
	GetBlockingRule: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetBlockingRuleQuery) => res
	},
	GetPromotionRule: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetPromotionRuleQuery) => res
	},
	GetReplenishmentRuleGroups: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetReplenishmentRuleGroupsQuery) => res
	},
	GetReplenishmentRules: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetReplenishmentRulesQuery) => res
	},
	UpdateBlockingRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: UpdateBlockingRuleMutation) => res
	},
	UpdatePromotionRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: UpdatePromotionRuleMutation) => res
	}
};
